var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.025,
    height: 16.026,
    viewBox: "0 0 16.025 16.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(167.833 -1.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(-167.333 1.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.615,17.275H3.16a2,2,0,0,1-1.993-1.993V4.827A2,2,0,0,1,3.16,2.833H8.388a.5.5,0,0,1,0,1H3.16a1,1,0,0,0-.993.994V15.282a.994.994,0,0,0,.993.993H13.615a1,1,0,0,0,.994-.993V10.054a.5.5,0,0,1,1,0v5.228A2,2,0,0,1,13.615,17.275Z",
    transform: "translate(-1.667 -1.749)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M15.628,1.066A2.084,2.084,0,0,1,17.1,4.623l-7.095,7.095a.5.5,0,0,1-.232.132L6.788,12.6a.5.5,0,0,1-.606-.606L6.928,9a.5.5,0,0,1,.132-.232l7.095-7.095A2.07,2.07,0,0,1,15.628,1.066ZM9.4,10.913l7-7a1.084,1.084,0,0,0-1.533-1.533l-7,7-.511,2.044Z",
    transform: "translate(-2.186 -1.566)",
    fill: "#979797"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabReport);
export default __webpack_public_path__ + "static/media/tab-report.335517f4fce2674494a3bed4837fa51e.svg";
export { ForwardRef as ReactComponent };